import queryString from "query-string";
import React, { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Container } from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";

import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import PlaceDetails from "../../Components/Places/PlaceDetails";
import { getRestaurantRequest } from "../../store/restaurants/actions";
import InfoRestaurant from "./components/InfoRestaurant";

const RestaurantDetails = () => {
  document.title = "Alimentação | Ecoguias - Admin Dashboard";

  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, loading } = useSelector((state) => state.Restaurant);

  const { search } = useLocation();
  const queryStringParams = queryString.parse(search);

  useEffect(() => {
    dispatch(getRestaurantRequest(id));
  }, [id, dispatch]);

  function renderPlaceDetails() {
    if (!data?.result) {
      return null;
    }

    return (
      <PlaceDetails
        loading={loading}
        data={data?.result?.restaurant}
        images={data?.result?.images}
        pathPaginationName="/restaurants"
        page={queryStringParams.page}
        menu={<InfoRestaurant data={data?.result?.restaurant} />}
      />
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Alimentação" pageTitle="Locais" />
        </Container>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>
            {renderPlaceDetails()}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default RestaurantDetails;
